import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://192.168.5.129:3001/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000 // 30 seconds timeout for face comparison
})

export const createVerification = async (sessionId, userData = {}, fingerprint = null) => {
  try {
    const response = await api.post('/verification', {
      sessionId,
      userData: {
        nome: userData.nome || '',
        cpf: userData.cpf || '',
        id_cliente: userData.id_cliente || null,
        id_billing: userData.id_billing || null
      },
      fingerprint
    })
    return response.data.data
  } catch (error) {
    console.error('Error creating verification:', error)
    throw error
  }
}

export const uploadDocumentFront = async (verificationId, blob, documentType) => {
  try {
    const formData = new FormData()
    formData.append('image', blob, 'document-front.jpg')
    formData.append('documentType', documentType)

    const response = await api.post(
      `/verification/${verificationId}/document/front`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return response.data.data
  } catch (error) {
    console.error('Error uploading document front:', error)
    throw error
  }
}

export const uploadDocumentBack = async (verificationId, blob, documentType) => {
  try {
    const formData = new FormData()
    formData.append('image', blob, 'document-back.jpg')
    formData.append('documentType', documentType)

    const response = await api.post(
      `/verification/${verificationId}/document/back`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return response.data.data
  } catch (error) {
    console.error('Error uploading document back:', error)
    throw error
  }
}

export const uploadSelfie = async (verificationId, blob) => {
  try {
    const formData = new FormData()
    formData.append('image', blob, 'selfie.jpg')

    const response = await api.post(
      `/verification/${verificationId}/selfie`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60000 // 60s — selfie upload includes liveness detection via Claude API
      }
    )

    return response.data.data
  } catch (error) {
    console.error('Error uploading selfie:', error)
    throw error
  }
}

export const uploadLivenessGIF = async (verificationId, blob) => {
  try {
    const formData = new FormData()
    formData.append('image', blob, 'liveness.gif')

    const response = await api.post(
      `/verification/${verificationId}/liveness-gif`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60000 // 60 seconds for GIF upload (can be large)
      }
    )

    return response.data.data
  } catch (error) {
    console.error('Error uploading liveness GIF:', error)
    throw error
  }
}

export const compareFaces = async (verificationId) => {
  try {
    console.log('[API] 🔄 Calling compareFaces...', verificationId)
    console.log('[API] Timestamp:', new Date().toISOString())

    const response = await api.post(`/verification/${verificationId}/compare`, {}, {
      timeout: 60000 // 60s — face comparison downloads images from S3 + Rekognition
    })

    console.log('[API] ✅ Response received at:', new Date().toISOString())
    console.log('[API] Response status:', response.status)
    console.log('[API] Response headers:', response.headers)
    console.log('[API] Response data:', response.data)
    console.log('[API] Response data.success:', response.data?.success)
    console.log('[API] Response data.data:', response.data?.data)
    console.log('[API] Response data.data.approved:', response.data?.data?.approved)

    if (!response.data || !response.data.data) {
      console.error('[API] ❌ Invalid response format:', response.data)
      throw new Error('Invalid response format from server')
    }

    return response.data.data
  } catch (error) {
    console.error('[API] ❌ compareFaces failed at:', new Date().toISOString())
    console.error('[API] Error type:', error.constructor.name)
    console.error('[API] Error code:', error.code)
    console.error('[API] Error message:', error.message)
    console.error('[API] Response status:', error.response?.status)
    console.error('[API] Response statusText:', error.response?.statusText)
    console.error('[API] Response data:', error.response?.data)
    console.error('[API] Full error:', error)
    throw error
  }
}

export const resolveToken = async (token) => {
  try {
    const response = await api.get(`/token/verify/${token}`)
    return response.data.data
  } catch (error) {
    console.error('Error resolving token:', error)
    throw error
  }
}

export const getVerificationStatus = async (verificationId) => {
  try {
    const response = await api.get(`/verification/${verificationId}/status`)
    return response.data.data
  } catch (error) {
    console.error('Error getting verification status:', error)
    throw error
  }
}

export default api
